import request from '@/utils/http'

// login:
function login (params: any) {
  return request({
    url: `sysUser/login`,
    method: 'post',
    data: params
  })
}

// upload：
// 上传图片获取权限
// 返回的是上传图片的URL 拿着URL发送put请求,把文件放进请求体,
// ContentType写image-jpg ContentType 必须传image/jpg
// 否则URL输入浏览器默认的是下载 返回的URL 截取问号? 之前的地址 就是访问图片的地址
function uploadImg (params: any) {
  return request({
    url: `upload/img`,
    method: 'get',
    params,
    headers: {
      // "Content-Type": "multipart/form-data"
      // "Content-Type": "application/x-www-form-urlencoded"
      // "Content-Type": "image/jpeg"
    }
  })
}

// 上传附件获取权限:
function uploadFile (params: any) {
  return request({
    url: `upload/adjunct`,
    method: 'get',
    params,
    headers: {
      // "Content-Type": "multipart/form-data"
      // // "Content-Type": "application/x-www-form-urlencoded"
      // "Content-Type": "image/jpeg"
    }
  })
}

// 模块参与组织设置与修改：即不同模块有不同的统计项‘
function typeOrganizationSaveTypeOrganization (params: any) {
  return request({
    url: `typeOrganization/saveTypeOrganization`,
    method: 'post',
    data: params
  })
}

// 查询模块参与组织设置 工资模块:0 资助模块:1
function typeOrganizationGetTypeOrganization (params: any) {
  return request({
    url: `typeOrganization/getTypeOrganization/${params.type}`,
    method: 'get'
  })
}

// 查询当前服务器系统时间:
function constantCurrentTime () {
  return request({
    url: `constant/currentTime`,
    method: 'get'
  })
}

export default {
  login,
  uploadImg,
  uploadFile,
  typeOrganizationSaveTypeOrganization,
  typeOrganizationGetTypeOrganization,
  constantCurrentTime
}
